import type { HomeScope } from '@UI/Pages/Home/Signals/homeScopeSignal';
import { DEFAULT_HOME_SCOPE } from '@UI/Pages/Home/Signals/homeScopeSignal';
import type { ComposedOrganization } from '@UI/Providers/CurrentOrganizationProvider/helpers/composeAssignedOrganizations';

/** Falls back to the whole perimeter when the stored scope names an organization or agency the caller no longer has. */
const resolveEffectiveHomeScope = (
	organizations: readonly ComposedOrganization[],
	scope: HomeScope,
): HomeScope => {
	if (scope.kind === 'organization') {
		return organizations.some((organization) => organization.id === scope.id)
			? scope
			: DEFAULT_HOME_SCOPE;
	}

	if (scope.kind === 'facility') {
		const exists = organizations.some((organization) =>
			organization.facilities.some((facility) => facility.id === scope.id),
		);

		return exists ? scope : DEFAULT_HOME_SCOPE;
	}

	return scope;
};

export default resolveEffectiveHomeScope;
